import styled from '@emotion/styled';
import isNumber from 'lodash/isNumber';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { color, font } from 'src/shared/styles/variables';

const Text = styled.p({
    color: color.blueBayoux,
    marginBottom: 21,
    lineHeight: '26px',
    textAlign: 'center',
    whiteSpace: 'pre',
    ...font.heavy(font.size.medium),
});

interface Props {
    currentScore: number;
    previousScore: number | undefined | null;
}

export const ReTriageScoreText: React.FC<Props> = ({ previousScore, currentScore }) => {
    const { t } = useTranslation();
    let scoreText = '';

    if (isNumber(previousScore) && previousScore > -1) {
        if (previousScore === currentScore) {
            scoreText = t('retriage:score.same', { score: currentScore });
        } else {
            const changeType = currentScore > previousScore ? 'increased' : 'decreased';
            const pointsDifference =
                currentScore > previousScore
                    ? currentScore - previousScore
                    : previousScore - currentScore;

            scoreText = t(`retriage:score.${changeType}`, {
                count: pointsDifference,
                score: currentScore,
            });
        }
    } else {
        // who5 assessment taken for the first time
        scoreText = t('retriage:score', { score: currentScore });
    }

    return <Text>{scoreText}</Text>;
};
